import React from 'react'

import { FilterPatchBody, KpiOptionObject } from 'types/GlobalKpiOption'
import { TWidgetSettings } from 'types/GlobalWidget'

import { useKpiOptionAttributeOptions } from 'redux/hooks/AttributeOptions'

import WidgetFilterSection from '../../FilterSection'
import { TPatchKpiOptionBody } from 'redux/api/KpiOptions'

interface FilterSectionProps {
  kpi: KpiOptionObject
  onClose: () => void
  settings: TWidgetSettings
  updateKpiOption: (body: TPatchKpiOptionBody) => void
}

const FilterSection = (props: FilterSectionProps) => {
  const { kpi, onClose, settings, updateKpiOption } = props

  const filterAttributeOptions = useKpiOptionAttributeOptions(
    settings,
    kpi,
    'filter_attribute'
  )

  return (
    // The same filter section is used for both widget and kpi:
    <WidgetFilterSection
      filterAttributeOptions={filterAttributeOptions}
      filters={kpi.filters}
      id={kpi.id}
      onClose={onClose}
      settings={settings}
      skipHelperText={true}
      updateFilters={(filters: FilterPatchBody[]) =>
        updateKpiOption({
          filters: filters
        })
      }
    />
  )
}

export default FilterSection
